import base64 from '../global/base64.js';
import md5 from '../global/md5.js';
import store from '@/store/index.js';
import timeHelper from '../global/timeHelper.js';
import axios from 'axios';

const fSmApiReq = async ({
  sReqUrl,
  sApiName,
  methodName,
  sReqJsonStr,
  mchId,
  userId,
  reqFrom,
  signType,
  reqToken,
  sApiRandomStr,
  sOrgSk,
}) => {
  //       // 验签秘钥
  let orgSk = sOrgSk || 'bEX0rCtD26XC0A2fwJtpd81RQYMHX4bf';
  //       sWaitSign := sOrgSk + rApiReq.REQ_JSON + rApiReq.REQ_TIME + sOrgSk;
  //       sSign := THashMD5.GetHashString(sWaitSign).ToLower;
  let reqTime = timeHelper.fGetNowTime(2);
  // 请求参数BASE64
  let reqJson = Base64.encode(sReqJsonStr);


  // let reqJson = Base64.encode(sReqJsonStr);
  // 组装签名
  let reqSign
  let js = {};
  js['METHOD_NAME'] = methodName || '';
  js['REQ_JSON'] = reqJson;
  js['MCH_ID'] = mchId || '';
  js['USER_ID'] = userId || '';
  js['REQ_IP'] = '127.0.0.1';
  js['REQ_FROM'] = 'WEB';
  js['REQ_VER'] = 'smElabel';
  js['REQ_TIME'] = reqTime;
  js['SIGN_TYPE'] = signType || 'token';
  js['ORG_AK'] = mchId
  js['REQ_SIGN'] = reqSign || ''
  js['REQ_LNG'] = 'CN'
  js['REQ_TOKEN'] = reqToken || store.state.smElabelOrgInfoToken;
  try {
    let res = await axios.post(sReqUrl, js);
    console.log('Received response:', res.data); // 请求后的日志记录
    if (!isObject(res.data)) {
      return {
        result: 'fail',
        msg: res.data
      }
    }
    if (res.data.result != 'sucess' && res.data.msg == 'tokenFail') {
    }
    return res.data;
  } catch (error) {
    console.error('Error in API request:', error); // 记录错误日志
    return {
      result: 'fail',
      msg: error.message
    }
    // throw error.message; // 或者返回一个标准的错误对象
  }
  // let res = await axios.post(sReqUrl, js);
  // console.log(res.data)

};
// {"result":"fail","msg":"Cannot create file "D:\smSrv\srv\sys\eLabelTpl\mchTpl\sysTpl-eP2-1-SC-20241228135912397R666.html". 系统找不到指定的路径。","sub_msg":"COPY_LIB"}
function isObject(obj) {
  return typeof obj === 'object' && obj !== null;
}

//主服务器接口
const fElabelMainAdminApi = async (obj) => {
  console.log(obj, 'fElabelMainAdminApi')
  let sReqUrl;
  sReqUrl = 'https://www.sanmibox.com/api/smLotMain/smElabel/adminApi'
  return fSmApiReq({
    sReqUrl,
    methodName: obj.methodName,
    sReqJsonStr: JSON.stringify(obj.js),
    mchId: obj.mchId || store.state.smElabelOrgInfo.orgId,
    userId: obj.userId || store.state.smElabelOrgInfo.userId,
    sApiRandomStr: obj.sApiRandomStr,
    signType: obj.signType
  });
};

const fElabelMainQueryApi = async (obj) => {
  console.log(obj, 'fElabelMainQueryApi')
  let sReqUrl = 'https://www.sanmibox.com/api/smLotMain/smElabel/queryApi';
  return fSmApiReq({
    sReqUrl,
    methodName: obj.methodName,
    sReqJsonStr: JSON.stringify(obj.js),
    mchId: store.state.smElabelOrgInfo.orgId,
    userId: store.state.smElabelOrgInfo.userId,
    sApiRandomStr: obj.sApiRandomStr,
  });
}
const fElabelSubAdminApi = async (obj) => {
  console.log(obj, 'fElabelSubAdminApi')
  let sReqUrl
  if (obj.srv_url) {
    sReqUrl = obj.srv_url + '/smElabel/adminApi';
  } else {
    sReqUrl = store.state.smElabelOrgInfo.srvUrl + '/smElabel/adminApi';
  }
  return fSmApiReq({
    sReqUrl,
    methodName: obj.methodName,
    sReqJsonStr: JSON.stringify(obj.js),
    mchId: store.state.smElabelOrgInfo.orgId,
    userId: store.state.smElabelOrgInfo.userId,
    sApiRandomStr: obj.sApiRandomStr,
  });
}
const fElabelSubQueryApi = async (obj) => {
  console.log(obj, 'fElabelSubQueryApi')
  let sReqUrl
  if (obj.srv_url) {
    sReqUrl = obj.srv_url + '/smElabel/queryApi';
  } else {
    sReqUrl = store.state.smElabelOrgInfo.srvUrl + '/smElabel/queryApi';
  }
  return fSmApiReq({
    sReqUrl,
    methodName: obj.methodName,
    sReqJsonStr: JSON.stringify(obj.js),
    mchId: store.state.smElabelOrgInfo.orgId,
    userId: store.state.smElabelOrgInfo.userId,
    sApiRandomStr: obj.sApiRandomStr,
  });
}

export default {
  fElabelMainAdminApi,
  fElabelMainQueryApi,
  fElabelSubAdminApi,
  fElabelSubQueryApi,
}



//////////////////
// WEBPACK FOOTER
// ./common/api/smElabelApi.js
// module id = null
// module chunks = 